import React from 'react';
import PropTypes from 'prop-types';
import errorBoundary from '@ifeng-fe/errorBoundary';
import Images from '@src/pc/components/Images';
import TimeListVideo from '@/src/mobile/components/TimeListVideo';
import Link from '@src/mobile/components/Link';
import { EVENT_LIST_INFLOW } from '@src/public/constants';
import { inFlowIframeJump } from '@src/public/utils';
import { isGrounds } from '@src/public/utils/app';
import styles from './index.css';
import Milestone from '../../Milestone';
import Watermark from '../../Watermark';

const Content = ({ content, showType, timeline }) => {
    const { img, video, description, link, milestone, watermark, longImg, title } = content;
    const { id } = timeline;

    let desc = '';
    const imgList = img && Array.isArray(img) ? [...img] : [];

    if (longImg) {
        desc = title;
        imgList.unshift({ url: longImg });
    } else {
        desc = description || title;
    }

    return (
        <div className={styles.wrap}>
            <div className={styles.desc}>
                <Milestone id={milestone} />
                <span className={styles.descText}>{desc}</span>
                {link ? (
                    <>
                        {showType === EVENT_LIST_INFLOW && !isGrounds ? (
                            <div
                                className={styles.descLink}
                                style={{ color: '#3091f5' }}
                                onClick={() => {
                                    inFlowIframeJump(link.url);
                                }}>
                                {link.title}
                            </div>
                        ) : (
                            <a href={link.url} className={styles.descLink} style={{ color: '#3091f5' }} target="_blank">
                                {link.title}
                            </a>
                        )}
                    </>
                ) : null}
                <Watermark id={watermark} />
            </div>
            {imgList.length ? (
                <div className={styles.picWrap}>
                    <Images img={imgList} showType={showType} id={id} />
                </div>
            ) : null}
            {video && video.url ? (
                <div className={styles.videoWrap}>
                    <TimeListVideo
                        videoConfig={{ mobileUrl: video.url, bigPosterUrl: video.poster }}
                        showType={showType}
                        timeId={id}
                    />
                </div>
            ) : null}
        </div>
    );
};

Content.propTypes = {
    content: PropTypes.object.isRequired,
    showType: PropTypes.string,
    timeline: PropTypes.object.isRequired,
};

export default errorBoundary(Content);
